<template>
  <div>
    <v-select
      :options="options"
      label="id"
      :disabled="
        tmp_kostenuebernahme &&
        value &&
        tmp_kostenuebernahme.id === value.id &&
        value.accept
      "
      v-model="tmp_kostenuebernahme"
      :class="{'hide-search': tmp_kostenuebernahme}"
      :placeholder="$t('kostenuebernahme_placeholder')"
      :clearable="false"
      :searchable="false"
    >
      <template slot="option" slot-scope="option">
        {{ option[$i18n.locale] }}
      </template>
      <template slot="selected-option" slot-scope="option">
        {{ option[$i18n.locale] }}
      </template>
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes" class="text"
          ><font-awesome-icon icon="sort-down"
        /></span>
      </template>
    </v-select>
    <button
      v-if="
        !(
          tmp_kostenuebernahme &&
          value &&
          value.accept &&
          tmp_kostenuebernahme.id === value.id
        )
      "
      @click="handleInput"
      class="btn btn-primary mt-3 d-block"
      :class="{ 'bg-contrast border-contrast': isHager }"
      :disabled="!tmp_kostenuebernahme"
    >
      {{ $t("actions.auswahl_uebernehmen") }}
    </button>
  </div>
</template>

<script>
export default {
  name: "VersicherungsartSelect",
  props: {
    options: { required: true },
    value: { type: Object, default: null },
  },
  data() {
    return {
      tmp_kostenuebernahme: this.value,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function(v) {
        this.tmp_kostenuebernahme = v;
      }
    }
  },
  methods: {
    handleInput() {
      this.$emit("input", this.tmp_kostenuebernahme);
    },
  },
};
</script>
